// import React from "react";
// import { FaCheckCircle, FaClock, FaHandshake } from "react-icons/fa";
// import './ourPromises.css'

// const promises = [
//   {
//     icon: <FaCheckCircle className="text-4xl text-green-500 mb-4" />,
//     title: "Top-Notch Quality",
//     className:'iconsPromises',
//     // description:
//     //   "We deliver pixel-perfect, high-performance websites tailored to your brand's vision and goals.",
//   },
//   {
//     icon: <FaClock className="text-4xl text-blue-500 mb-4" />,
//     title: "On-Time, Every Time",
//     className:'iconsPromises',
//     // description:
//     //   "We value your time. Our agile process ensures your project is delivered without delays.",
//   },
//   {
//     icon: <FaHandshake className="text-4xl text-yellow-500 mb-4" />,
//     title: "Ongoing Support",
//     className:'iconsPromises',
//     // description:
//     //   "From launch to growth, we’re here to support you with updates, fixes, and improvements.",
//   },
// ];

// const PromisesSection = () => {
//   return (
//     <section className="bg-white py-16 px-4 text-center divContainerMain">
//       <h1 className="ourPromiseTitle">Our Promises</h1>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
//         {promises.map((promise, index) => (
//           <div
//             key={index}
//             className=" bg-gray-50 p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300"
//           >
//             {promise.icon}
//             <h3 className="text-xl font-semibold text-gray-700 mb-2">{promise.title}</h3>
//             <p className="text-gray-600 text-sm">{promise.description}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default PromisesSection;

// Created new code here
import React, { useEffect } from "react";
import { FaCheckCircle, FaClock, FaHandshake } from "react-icons/fa";
import { FaArrowDownLong } from "react-icons/fa6";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ourPromises.css";
// import OurServicesimage from "../../assets/image/services image.mp4";

const promises = [
  {
    icon: <FaCheckCircle className="step-icon green" />,
    title: "20+ Projects Delivered",
  },
  {
    icon: <FaClock className="step-icon blue" />,
    title: "7+ Years of Continuous Innovation",
  },
  {
    icon: <FaHandshake className="step-icon yellow" />,
    title: "15+ Clients of 7 Years",
  },
];

const PromisesSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section
      className="promises-wrapper rounded-bottom-section"
      data-aos="fade-up"
    >
      <h5 className="industriesTitle" data-aos="fade-down">
        -- Starlinklab Our Promises
      </h5>
      <h1 className="ourPromiseTitle" data-aos="zoom-in">
        Our Promises
      </h1>
      <p
        className="text-lg text-gray-400 ourPromisessubTitle"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        We don’t just deliver projects — we deliver trust, innovation, and
        results. Every line of code, every design, and every solution we create
        is built around these promises:
        <b className="pointsOfSubTitle">
          {" "}
          Quality First , On-Time Delivery,Transparency & Trust, Client-Centric
          Approach,Long-Term Support , Innovation-Driven
        </b>
      </p>

      <div className="promises-grid ">
        {/* Left: Steps */}
        <div className="steps-column" data-aos="fade-right">
          {promises.map((promise, index) => (
            <div
              key={index}
              className="step-block"
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              {promise.icon}
              <h3 className="step-title">{promise.title}</h3>
              {index < promises.length - 1 && (
                <FaArrowDownLong className="arrow-down" />
              )}
            </div>
          ))}
        </div>

        {/* Right: image */}
        <div className="image-column" data-aos="fade-left">
          <div className="image-wrapper">
            <img
              src={require("../../assets/ourPromisses/ourPromisesRightSideImg.jpg")} // replace with your actual image path
              alt="Our Services Preview"
              className="image-element"
            />
          </div>
        </div>
      </div>
      {/* <p>
        Our business is primed to respond quickly – often within 24 hours,{" "}
        <br></br>
        if not sooner! We value swiftness and strive to make sure our customers
        are provided with speedy service.
      </p> */}
      <p>
       We deliver fast, reliable, and efficient solutions—often responding within 24 hours. With us,
        you get more than an IT partner—you get a team dedicated to turning your vision into success.
        </p>
    </section>
  );
};

export default PromisesSection;
